<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" class="pa-0 ma-0">
        <DashboardWidget
          ref="refDashboardWidget"
          @leave="routeLeaveAction"
        ></DashboardWidget>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
::v-deep .container--fluid {
  padding: 0px !important;
}
</style>
<script>
// @ is an alias to /src
import DashboardWidget from "../components/dashboard/DashboardWidget.vue";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "Home",
  components: {
    DashboardWidget,
  },
  data() {
    return {
      leave: true,
    };
  },
  watch: {
    $route: {
      immediate: true,
      async handler(newValue, oldValue) {
        await this.$auth.loadPermissions(this.$auth.user.email);
        if (!this.$security.checkUserAccess("ViewDashboard")) {
          this.$router.push({ path: "/" });
        } else {
          let tenantid = sessionStorage.getItem("tenantId");
          let meetingTypeStorageKey = "meetingType#" + tenantid;
          let meetingType = localStorage.getItem(meetingTypeStorageKey);
          if (meetingType) this.setMeetingType(meetingType);
        }
      },
    },
  },
  // beforeCreate() {
  //   if (!this.$security.checkUserAccess("ViewDashboard"))
  //     this.$router.push({ path: "/" });
  // },
  methods: {
    routeLeaveAction(value) {
      this.leave = value;
    },
    ...mapActions({
      setMeetingType: "meeting/setMeetingType",
    }),
  },
  /*beforeRouteLeave(to, from, next) {
    console.log(this.leave, "beforeRouteLeave");
    if (this.leave == true) {
      next(true);
    } else {
      // 2. Make this async
      let answer = window.confirm(
        "you might lose the data, please save the data before you leave."
      );
      if (answer) {
        // 3. Try/catch to confirm the resolve
        try {
          // Resolved
          next();
        } catch (err) {
          // Rejected
          next(false);
          log(err);
        }
      } else {
        next(false);
      }
    }
  },*/
};
</script>
